import classnames from 'classnames';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { MODAL_IDS } from '@/kit/Modal/keys';
import IconChecked from './icon_checked.svg';
import IconUnchecked from './icon_unchecked.svg';
import s from './index.module.scss';

const id = MODAL_IDS.operation_types_select_modal;

export const OperationTypesSelectModal = props => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal {...props} />;
};

export const Modal = ({ selected = [], onChange, options = [] }) => {
  const { closeModal } = useModal();

  const allChecked =
    selected.length === 0 || options.length === selected.length;

  const handleChange = option => {
    onChange(
      selected.includes(option.value)
        ? selected.filter(i => i !== option.value)
        : [...selected, option.value],
    );
  };

  const content = (
    <div className={classnames(s.modal, 'scr_modal_grid')}>
      <h1 className="f-article-accent">Operation type</h1>
      <div className={s.content}>
        <div className={s.list}>
          <div
            className={s.option}
            onClick={() =>
              options.length === selected.length
                ? onChange([])
                : onChange(options.map(({ value }) => value))
            }
          >
            <span className="f-body-regular">All operations</span>
            <img
              src={allChecked ? IconChecked : IconUnchecked}
              alt="icon"
              width={20}
              height={20}
            />
          </div>
          {options.map(option => (
            <div
              key={option.value}
              className={s.option}
              onClick={() => handleChange(option)}
            >
              <span className="f-body-regular">{option.label}</span>
              <img
                src={
                  selected.includes(option.value) || allChecked
                    ? IconChecked
                    : IconUnchecked
                }
                alt="icon"
                width={20}
                height={20}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  );
};
